import { Button, ButtonVariant, PageHeader } from '@egw/components'
import { useIsMobileScreen } from '@egw/components/src/popover/hooks/layout-hook'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { type FC } from 'react'
import { useNavigate } from 'react-router'
import CardFront from '../../components/card-front/card-front'

export interface DebitCardActivateSuccessProps {
  alias: string
}

export const DebitCardActivateSuccess: FC<DebitCardActivateSuccessProps> = ({ alias }) => {
  const { t } = useTranslation('features-account')
  const isMobileScreen = useIsMobileScreen()
  const navigate = useNavigate()

  return (
    <>
      <PageHeader
        title={t('debit_card.activate.card_activated')}
        subtitle={t('debit_card.title')}
        backLinkUrl={WEALTH_ROUTES.CHECKING_ACCOUNT_DEBIT_CARD_ACTIVATE_SUCCESS.backPath?.replace(
          ':alias',
          alias.toString(),
        )}
      />
      <div className="default-page-width-wrapper py-8 pb-12 md:bg-gray-50">
        <div className="default-page-width flex flex-col align-center justify-center items-center">
          <div className="justify-center align-center flex flex-col items-center px-3">
            <CardFront className="opacity-40 max-w-[340px]" width={isMobileScreen ? '100%' : 340} />
          </div>
        </div>
      </div>
      <div className="justify-center align-center flex flex-col items-center p-6 bg-white sm:w-auto">
        <div className="mt-6 mb-4 flex md:items-center flex-col px-6 md:px-0">
          <CheckCircleIcon className="mr-2 h-12 w-12 fill-green-400" />
          <p className="mt-4 text-green-500 text-2xl font-thin ">{t('debit_card.activate.activate_success')}</p>
          <p className="mt-6 max-w-[440px] md:text-center text-body">
            {t('debit_card.activate.please_note_expiration_date')}
          </p>
        </div>
        <Button
          variant={ButtonVariant.Secondary}
          id="activateCardDone"
          className="mb-4 md:mb-0 md:mr-4 w-full md:w-max mt-6"
          onClick={() => {
            void navigate(WEALTH_ROUTES.CHECKING_ACCOUNT_DEBIT_CARD.path.replace(':alias', alias.toString()))
          }}
        >
          {t('default.done')}
        </Button>
      </div>
    </>
  )
}
